// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NM0jP","close":"mUO2g","desc":"rMP62","emailLine":"_2hu5m","inputContent":"_2IIfx","errorTip":"_1et6W","btnLine":"Qq-DF","emailBtn":"BNkck","msgBtn":"_1fB_9"};